import logoPng from "../assets/logo.png";

interface HeaderProps {
  activeTab: string;
  navigateTo: (pageId: string) => void;
  mobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
}

export function Header({ activeTab, navigateTo, mobileMenuOpen, toggleMobileMenu }: HeaderProps) {
  const getNavLinkClass = (pageId: string) => {
    return `nav-link text-sm uppercase tracking-widest hover:text-dourado transition duration-300 font-medium ${
      activeTab === pageId ? "active-link" : ""
    }`;
  };

  return (
    <nav className="fixed w-full z-50 bg-petroleo/95 text-white shadow-lg backdrop-blur-sm transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
        <div className="flex justify-between items-center h-24">
          {/* Logo e Título */}
          <div
            className="flex-shrink-0 flex items-center gap-3 cursor-pointer"
            onClick={() => navigateTo("home")}
          >
            <img
              src={logoPng}
              alt="Logo Hórus 147"
              className={`w-14 h-14 object-cover rounded-full border-2 border-white shadow-inner bg-dourado transition-all duration-300 ${
                activeTab === "home" ? "hidden" : ""
              }`}
            />
            <span
              className={`font-titulo font-bold text-2xl tracking-wider uppercase transition-all duration-300 ${
                activeTab === "home" ? "hidden" : ""
              }`}
            >
              Hórus 147
            </span>
          </div>

          {/* Menu Desktop */}
          <div className="hidden md:flex space-x-8 items-center">
            <button onClick={() => navigateTo("home")} className={getNavLinkClass("home")}>
              Início
            </button>
            <button onClick={() => navigateTo("quem-somos")} className={getNavLinkClass("quem-somos")}>
              A Loja
            </button>
            <button onClick={() => navigateTo("estandarte")} className={getNavLinkClass("estandarte")}>
              O Estandarte
            </button>
            <button onClick={() => navigateTo("contato")} className={getNavLinkClass("contato")}>
              Contato
            </button>
          </div>

          {/* Menu Mobile Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMobileMenu}
              className="text-dourado hover:text-white focus:outline-none p-2"
            >
              <i className="fa-solid fa-bars text-3xl"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Menu Mobile Content */}
      <div
        id="mobile-menu"
        className={`absolute top-24 left-0 w-full bg-petroleo/95 shadow-xl backdrop-blur-sm z-10 flex flex-col items-center py-6 space-y-6 md:hidden ${
          mobileMenuOpen ? "open" : ""
        }`}
      >
        <button
          onClick={() => navigateTo("home")}
          className="nav-link-mobile text-white text-lg uppercase tracking-widest hover:text-dourado transition duration-300 font-medium"
        >
          Início
        </button>
        <button
          onClick={() => navigateTo("quem-somos")}
          className="nav-link-mobile text-white text-lg uppercase tracking-widest hover:text-dourado transition duration-300 font-medium"
        >
          A Loja
        </button>
        <button
          onClick={() => navigateTo("estandarte")}
          className="nav-link-mobile text-white text-lg uppercase tracking-widest hover:text-dourado transition duration-300 font-medium"
        >
          O Estandarte
        </button>
        <button
          onClick={() => navigateTo("contato")}
          className="nav-link-mobile text-white text-lg uppercase tracking-widest hover:text-dourado transition duration-300 font-medium"
        >
          Contato
        </button>
      </div>
    </nav>
  );
}
